import { action, observable, makeObservable } from 'mobx';

class BooleanStore {
  @observable value: boolean = false;

  constructor(defaultValue: boolean = false) {
    makeObservable(this);
    this.value = defaultValue;
  }

  @action
  on() {
    this.value = true;
  }

  @action
  off() {
    this.value = false;
  }

  @action
  toogle() {
    this.value = !this.value;
  }
}

export { BooleanStore };
